export default "__VITE_ASSET__e46a0c1c__"